import { BaseDto } from "@/shared/dtos/base-dto";

export class FormDateDiff extends BaseDto {
  public DateTime1!: string;
  public DateTime2!: string;
}